import React, {useState} from 'react';
import {Accordion} from '@mantine/core';

function AccordionLabel({selected}) {
    return <p className={selected ? "accordion__label--selected" : "accordion__label"}>Detalle de cobertura</p>;
}

function AccordionDetails({product}) {
    const [value, setValue] = useState(null);

    const productsInfo = {
        "automotor": [
            {
                title: "Tercero básico",
                text: "Responsabilidad civil + Robo e incendio."
            },
            {
                title: "Tercero completo",
                text: "Responsabilidad civil + Robo e incendio total y parcial + Destrucción total + Adicionales (cristales, granizo, cerraduras, etc.)."
            },
            {
                title: "Todo riesgo",
                text: "Seguro total con franquicia."
            }
        ],
        "motovehículo": [
            {
                title: "Responsabilidad civil",
                text: "Seguro contra Terceros únicamente."
            },
            {
                title: "Tercero básico",
                text: "Además del seguro contra Terceros se cubre Incendio y Robo total."
            },
            {
                title: "Tercero completo",
                text: "Además del seguro contra Terceros se cubre Incendio, Robo y Accidente total."
            },
            {
                title: "Full",
                text: "Además del seguro contra Terceros se cubre Incendio y Robo total y parcial, y Accidente total."
            },
            {
                title: "Todo riesgo",
                text: "Se cubren los daños parciales superiores a la franquicia variable que elijas."
            }
        ],
        "hogar": [
            {
                title: "Incendio",
                text: "Cubre los Daños Materiales ocasionados por la acción del Fuego, Rayo o Explosión. También se incluye el adicional de Huracán, Ciclón y Tornado."
            },
            {
                title: "Responsabilidad Civil",
                text: "Se protege al Asegurado por reclamos de terceros que emerjan de su Responsabilidad Extracontractual, como consecuencia de daños y perjuicios producidos dentro y fuera del Hogar."
            },
            {
                title: "Cristales",
                text: "Cobertura para rotura de cristales, vidrios y espejos instalados en posición vertical. Se incluyen los gastos normales de colocación."
            },
            {
                title: "Mobiliario y electrodomésticos",
                text: "Cubre Robo, Hurto o su tentativa del mobiliario. Se incluyen electrodomésticos de línea blanca vinculados a la cocina y limpieza del hogar. Adicionalmente, se amparan los daños que haya sufrido la vivienda asegurada como consecuencia de Robo."
            },
            {
                title: "Aparatos electrónicos",
                text: "Cubre a los equipos electrónicos de pérdidas o daños causados por Incendio, Robo (Excluido el Hurto) y/o Daños por accidente. Se incluye el adicional de fluctuaciones eléctricas. Bienes asegurables: Tv, equipos de Audio, Videograbadoras, Home Theater, Consolas de video Juegos, Pc de Escritorio, Hornos, Microondas, Aire Acondicionado, Termo tanques eléctricos, Cocinas, Anafes, Grupo Electrógeno, Alarma, Mecanismo de portones eléctricos, entre otros."
            },
            {
                title: "Adicionales:",
                list: [
                    {
                        subtitle: "Aparatos electrónicos:",
                        text: "Robo de la Bicicleta y/o Monopatín dentro y/o fuera del domicilio asegurado. Se excluye expresamente Hurto, Robo Parcial y Robo de accesorios."
                    },
                    {
                        subtitle: "Notebook / Tablet:",
                        text: "Cubre Incendio, Rayo, Explosión, Robo y Daños como consecuencia de accidentes dentro de la República Argentina. Se excluye expresamente Hurto."
                    },
                    {
                        subtitle: "Objetos Varios:",
                        text: "Cubre las pérdidas o daños causados por Incendio, Robo y daños por accidentes en el Mundo. Bienes asegurables: Cámaras fotográficas, Filmadoras, Cuadros, Objetos de arte o colección, Instrumentos Musicales, Micrófonos, Amplificadores, Parlantes, Potencias, Consolas de audio y sonido, Relojes, Anteojos, Lentes de contacto, Joyas, Alhajas y Pieles, entre otros."
                    }
                ]
            },
            {
                title: "Beneficios sin costo:",
                list: [
                    {
                        text: "Asistencia en Viaje a las Personas."
                    },
                    {
                        text: "Asistencia Domiciliaria."
                    },
                    {
                        text: "Llamado al Doctor."
                    }
                ]
            }
        ],
        "bicicleta": [
            {
                text: "Cubre el Robo de la Bicicleta y/o Monopatín dentro y/o fuera del domicilio asegurado. Se excluye expresamente Hurto, Robo Parcial y Robo de accesorios."
            }
        ],
        "notebook": [
            {
                text: "Cubre Incendio, Rayo, Explosión, Robo y Daños como consecuencia de accidentes dentro de la República Argentina. Se excluye expresamente Hurto."
            }
        ],
        "asistenciaviajero": [
            {
                title: "Cobertura nacional e internacional",
                text: "Acceso a atención médica y asistencia las 24 horas, los 7 días de la semana, en cualquier lugar del mundo durante tu viaje."
            },
            {
                title: "Asistencia médica",
                text: "Cubre gastos de consultas, hospitalización, medicamentos, y atención en caso de enfermedad o accidente mientras estés en el exterior."
            },
            {
                title: "Adicionales:",
                list: [
                    {
                        text: "Repatriación sanitaria."
                    },
                    {
                        text: "Pérdida de equipaje ante extravío, robo o demora."
                    },
                    {
                        text: "Gastos por cancelación, reprogramación o interrupción del viaje, entre otros."
                    }
                ]
            }
        ],
        "robosvarios": [
            {
                text: "Cubre las pérdidas o daños causados por Incendio, Robo y daños por accidentes en el Mundo. Bienes asegurables: Cámaras fotográficas, Filmadoras, Cuadros, Objetos de arte o colección, Instrumentos Musicales, Micrófonos, Amplificadores, Parlantes, Potencias, Consolas de audio y sonido, Relojes, Anteojos, Lentes de contacto, Joyas, Alhajas y Pieles, entre otros."
            }
        ],
    };

    productsInfo["tablet"] = productsInfo["notebook"];
    productsInfo["monopatin"] = productsInfo["bicicleta"];

    return (
        <Accordion radius="md" chevronPosition="right" className="accordion" value={value} onChange={setValue}
                   classNames={{chevron: "accordion__chevron"}}>
            {product in productsInfo && (
                <Accordion.Item value="Detalle de cobertura">
                    <Accordion.Control>
                        <AccordionLabel selected={value === "Detalle de cobertura"}/>
                    </Accordion.Control>
                    <Accordion.Panel>
                        {productsInfo[product].map((item, index) => (
                            <div key={index}>
                                <p className={`accordion__title ${index === 0 ? 'accordion__firstTitle' : ''}`}>
                                    {item.title}
                                </p>
                                {item.text && <p className="accordion__text">{item.text}</p>}
                                {item.list && (
                                    <ul>
                                        {item.list.map((subitem, subindex) => (
                                            <li key={subindex}>
                                                {subitem.subtitle && (
                                                    <p className="accordion__subtitle">{subitem.subtitle}</p>
                                                )}
                                                <p className="accordion__listText">{subitem.text}</p>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))}
                    </Accordion.Panel>
                </Accordion.Item>
            )}
        </Accordion>
    );
}

export default AccordionDetails;